"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExtensions = exports.MarkName = exports.NodeName = void 0;
const extensions_1 = require("remirror/extensions");
const PreformattedExtension_1 = require("./PreformattedExtension/PreformattedExtension");
const AssetLinkExtension_1 = require("./LinkExtension/AssetLinkExtension");
const LinkExtension_1 = require("./LinkExtension/LinkExtension");
const ImageExtension_1 = require("./ImageExtension/ImageExtension");
const CommandsExtension_1 = require("./CommandsExtension/CommandsExtension");
const AssetImageExtension_1 = require("./ImageExtension/AssetImageExtension");
const DAMImageExtension_1 = require("./ImageExtension/DAMImageExtension");
const CodeBlockExtension_1 = require("./CodeBlockExtension/CodeBlockExtension");
const ClearFormattingExtension_1 = require("./ClearFormattingExtension/ClearFormattingExtension");
const UnsupportedNodeExtension_1 = require("./UnsuportedExtension/UnsupportedNodeExtension");
const FetchUrlExtension_1 = require("./FetchUrlExtension/FetchUrlExtension");
const extension_react_tables_1 = require("@remirror/extension-react-tables");
const extension_react_component_1 = require("@remirror/extension-react-component");
var NodeName;
(function (NodeName) {
    NodeName["Image"] = "image";
    NodeName["CodeBlock"] = "codeBlock";
    NodeName["AssetImage"] = "assetImage";
    NodeName["DAMImage"] = "DAMImage";
    NodeName["Text"] = "text";
    NodeName["TableControllerCell"] = "tableControllerCell";
    NodeName["tableCell"] = "tableCell";
    NodeName["hardBreak"] = "hardBreak";
    NodeName["Unsupported"] = "unsupportedNode";
})(NodeName = exports.NodeName || (exports.NodeName = {}));
var MarkName;
(function (MarkName) {
    MarkName["Link"] = "link";
    MarkName["AssetLink"] = "assetLink";
})(MarkName = exports.MarkName || (exports.MarkName = {}));
const createExtensions = (context, enableDecorations = true) => {
    return () => {
        return [
            new CommandsExtension_1.CommandsExtension(),
            new extensions_1.BoldExtension(),
            new extensions_1.DocExtension(),
            new extensions_1.HeadingExtension(),
            new extensions_1.ItalicExtension(),
            new extensions_1.NodeFormattingExtension({ indents: [] }),
            new extensions_1.ParagraphExtension(),
            new extensions_1.HardBreakExtension(),
            new CodeBlockExtension_1.CodeBlockExtension({ enableDecorations }),
            new PreformattedExtension_1.PreformattedExtension({ enableDecorations }),
            new extensions_1.UnderlineExtension(),
            new extensions_1.HistoryExtension(),
            new ImageExtension_1.ImageExtension(),
            new ImageExtension_1.ImageExtension({ preferPastedTextContent: false }),
            new AssetImageExtension_1.AssetImageExtension({
                matrixDomain: context.matrix.matrixDomain,
            }),
            new DAMImageExtension_1.DAMImageExtension(),
            new LinkExtension_1.LinkExtension(),
            new AssetLinkExtension_1.AssetLinkExtension({
                matrixDomain: context.matrix.matrixDomain,
            }),
            new UnsupportedNodeExtension_1.UnsupportedNodeExtension(),
            new ClearFormattingExtension_1.ClearFormattingExtension(),
            new extensions_1.BulletListExtension(),
            new extensions_1.ListItemExtension(),
            new extensions_1.OrderedListExtension(),
            new extensions_1.HorizontalRuleExtension(),
            new extensions_1.PlaceholderExtension(),
            new FetchUrlExtension_1.FetchUrlExtension({
                fetchUrl: context.resolveNodeToUrl,
            }),
            new extensions_1.TextExtension(),
            new extension_react_tables_1.TableExtension(),
            new extension_react_component_1.ReactComponentExtension(),
        ];
    };
};
exports.createExtensions = createExtensions;
